import { graphql, useStaticQuery } from '@amazeelabs/gatsby-plugin-operations';
import { EventCategoryTermsQuery } from '@custom/schema';

export const useEventCategoryTermsQuery = () =>
  useStaticQuery<EventCategoryTermsQuery>(graphql(EventCategoryTermsQuery));
